import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '@app/services/api/api.service';
import { ProformaService } from '@app/services/api/proforma.service';
import * as fromRoot from '@core/reducers/root.reducer';

import {
  AddDelayProformas,
  AddDelayProformasFail,
  AddDelayProformasSuccess,
  AddProducts,
  AddProductsFail,
  AddProductsSuccess,
  AllDepartmentSheets,
  AllDepartmentSheetsFail,
  AllDepartmentSheetsSuccess,
  AllEnrichProducts,
  AllEnrichProductsFail,
  AllEnrichProductsSuccess,
  Create,
  CreateFail,
  CreateSuccess,
  DeleteAllProforma,
  DeleteAllProformaFail,
  DeleteAllProformaSuccess,
  DeleteProduct,
  DeleteProductFail,
  DeleteProductSuccess,
  DownloadEnrichProducts,
  EnrichProducts,
  EnrichProductsFail,
  EnrichProductsSuccess,
  ExportGroup,
  ExportGroupDownload,
  ExportGroupDownloadSuccess,
  ExportGroupFail,
  ExportGroupSuccess,
  Generate,
  GenerateFail,
  GenerateSuccess,
  GetUploadLink,
  GetUploadLinkFail,
  Load,
  LoadFail,
  LoadSuccess,
  MigrateProductsShipments,
  MigrateProductsShipmentsFail,
  MigrateProductsShipmentsSuccess,
  N2Department,
  N2DepartmentFail,
  N2DepartmentSuccess,
  NewProformaProduct,
  NewProformaProductFail,
  NewProformaProductSuccess,
  NotifyFileUpload,
  ProcessFileWithSkusSuccess,
  ProformaActionTypes,
  ProformasDetailDownloabled,
  RecalculateWeightedFob,
  RecalculateWeightedFobFail,
  Search,
  SearchFail,
  SearchProduct,
  SearchProductFail,
  SearchProductSuccess,
  SearchSuccess,
  ShipmentUpdateCancel,
  ShipmentUpdateCancelFail,
  ShipmentUpdateCancelSuccess,
  Summary,
  SummarySuccess,
  SupplierFile,
  SupplierFileFail,
  SupplierFileSuccess,
  SupplierFileUpdate,
  Update,
  UpdateCancel,
  UpdateCancelFail,
  UpdateCancelSuccess,
  UpdateFail,
  UpdateGenerate,
  UpdateGenerateFail,
  UpdateGenerateSuccess,
  UpdateOne,
  UpdateOneFail,
  UpdateOneSuccess,
  UpdateProformaEditSuccess,
  UpdateShipment,
  UpdateShipmentSuccess,
  UpdateStatus,
  UpdateStatusSuccess,
  UpdateSuccess,
  UploadFile,
  UploadFileFail,
  UploadFileSuccess,
  UpsertEnrichProducts,
  UpsertEnrichProductsFail,
  UpsertEnrichProductsSuccess,
  VoidAction
} from '@core/actions/proforma.actions';

import {
  AcceptChangesSuccess,
  DiscrepancyActionTypes
} from '@core/actions/discrepancy.actions';

import * as FollowShipmentActions from '@core/actions/follow-shipment.actions';

import * as ProductShipmentActions from '@core/actions/product-shipment.actions';

import { Proforma } from '@app/models';
import { FlashService } from '@app/services/flash.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action, Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import {
  catchError,
  concatMap,
  exhaustMap,
  filter,
  map,
  switchMap,
  tap
} from 'rxjs/operators';
import { ProformaWeightedFobModalComponent } from '../../../modules/proformaUI/containers/proforma-weighted-fob-modal/proforma-weighted-fob-modal.component';
import { ProductDisabledFobComponent } from '../../proformaUI/containers/product-disabled-fob/product-disabled-fob.component';
// import * as ProformaActionTypes from '@app/modules/core/actions/proforma.actions';

@Injectable()
export class ProformaEffects {
  constructor(
    private actions$: Actions,
    private proformasApi: ProformaService,
    private api: ApiService,
    private fs: FlashService,
    private modal: NgbModal,
    private store: Store<any>,
    private router: Router
  ) {}

  _modalRef;

  @Effect()
  newProformaProduct$ = this.actions$.pipe(
    ofType<NewProformaProduct>(ProformaActionTypes.NewProformaProduct),
    map(action => [
      action.shipmentId,
      action.selectedProductIds,
      action.providerId,
      action.udnCountry
    ]),
    switchMap(([shipmentId, selectedProductIds, providerId, udnCountry]) => {
      return this.proformasApi
        .newProformaProduct(
          shipmentId,
          selectedProductIds,
          providerId,
          udnCountry
        )
        .pipe(
          switchMap((data: any) => {
            return [new NewProformaProductSuccess(data)];
          }),
          catchError(error => of(new NewProformaProductFail(error)))
        );
    })
  );

  @Effect()
  migrateProductsShipments$ = this.actions$.pipe(
    ofType<MigrateProductsShipments>(
      ProformaActionTypes.MigrateProductsShipments
    ),
    map(action => [action.proformaId, action.shipmentId, action.pcsId]),
    switchMap(([proformaId, shipmentId, pcsId]) => {
      return this.proformasApi
        .migrateProductShipment({ proformaId, shipmentId, pcsId })
        .pipe(
          switchMap((data: any) => {
            return [new MigrateProductsShipmentsSuccess(data)];
          }),
          catchError(error => of(new MigrateProductsShipmentsFail(error)))
        );
    })
  );

  @Effect()
  getLink$ = this.actions$.pipe(
    ofType<GetUploadLink>(ProformaActionTypes.GetUploadLink),
    map(action => [action.file, action.uploadType, action.data]),
    switchMap(([file, uploadType, data]) => {
      return this.api.massiveLink(file, uploadType, data).pipe(
        switchMap((link: any) => {
          return [new UploadFile(link, file, uploadType, data)];
        }),
        catchError(error => of(new GetUploadLinkFail(error)))
      );
    })
  );

  @Effect()
  uploadFile$ = this.actions$.pipe(
    ofType<UploadFile>(ProformaActionTypes.UploadFile),
    map(action => [action.link, action.file, action.uploadType, action.data]),
    exhaustMap(([link, file, uploadType, data]) => {
      const url = link.signedUrl;
      const fileId = link.id;
      return this.api.uploadFollowFile(url, file).pipe(
        map(response => {
          if (uploadType === 'massiveEnrich') {
            return new NotifyFileUpload(fileId, uploadType);
          }
          return new AllEnrichProducts({ SupplierId: data.SupplierId });
        }),
        catchError(error => {
          return of(new UploadFileFail(error));
        })
      );
    })
  );

  @Effect()
  notifyFileUpload$ = this.actions$.pipe(
    ofType<NotifyFileUpload>(ProformaActionTypes.NotifyFileUpload),
    map(action => [action.id, action.uploadType]),
    exhaustMap(([id, uploadType]) => {
      return this.api.notifyFileUpload(id, { processType: uploadType }).pipe(
        concatMap(response => {
          return [new UploadFileSuccess(uploadType)];
        }),
        catchError(error => {
          return of(new UploadFileFail(error));
        })
      );
    })
  );

  @Effect({ dispatch: false })
  downloadEnrichProducts$ = this.actions$.pipe(
    ofType<DownloadEnrichProducts>(ProformaActionTypes.DownloadEnrichProducts),
    map(action => [action.data]),
    tap(([data]) => this.proformasApi.exportEnrichProducts(data))
  );

  @Effect()
  allDepartmentSheets$: Observable<Action> = this.actions$.pipe(
    ofType<AllDepartmentSheets>(ProformaActionTypes.AllDepartmentSheets),
    map(action => {}),
    switchMap(() =>
      this.proformasApi.getDepartmentSheets().pipe(
        map(
          departmentSheetData =>
            new AllDepartmentSheetsSuccess(departmentSheetData)
        ),
        catchError(error => of(new AllDepartmentSheetsFail(error)))
      )
    )
  );

  @Effect()
  n2Department$: Observable<Action> = this.actions$.pipe(
    ofType<N2Department>(ProformaActionTypes.N2Department),
    map(action => {}),
    switchMap(() =>
      this.proformasApi.getN2Department().pipe(
        map(
          departmentSheetData => new N2DepartmentSuccess(departmentSheetData)
        ),
        catchError(error => of(new N2DepartmentFail(error)))
      )
    )
  );

  @Effect()
  supplierFile$: Observable<Action> = this.actions$.pipe(
    ofType<SupplierFile>(ProformaActionTypes.SupplierFile),
    map(action => action.FollowId),
    switchMap(FollowId =>
      this.proformasApi.getSupplierFileInfo(FollowId).pipe(
        map(enrichData => new SupplierFileSuccess(enrichData)),
        catchError(error => of(new SupplierFileFail(error)))
      )
    )
  );

  @Effect()
  supplierFileUpdate$: Observable<Action> = this.actions$.pipe(
    ofType<SupplierFileUpdate>(ProformaActionTypes.SupplierFileUpdate),
    map(action => [
      action.FileId,
      action.status,
      action.FollowId,
      action.followType
    ]),
    concatMap(([FileId, status, FollowId, followType]) =>
      this.proformasApi.supplierFileUpdate(FileId, status, followType).pipe(
        map(dataReturn => {
          return new SupplierFile(FollowId);
        }),
        catchError(error => of(new SupplierFileFail(error)))
      )
    )
  );

  @Effect()
  allEnrichProducts$: Observable<Action> = this.actions$.pipe(
    ofType<AllEnrichProducts>(ProformaActionTypes.AllEnrichProducts),
    map(action => action.data),
    switchMap(data =>
      this.proformasApi.getEnrichProducts(data).pipe(
        map(enrichData => new AllEnrichProductsSuccess(enrichData)),
        catchError(error => of(new AllEnrichProductsFail(error)))
      )
    )
  );

  @Effect()
  enrichProducts$: Observable<Action> = this.actions$.pipe(
    ofType<EnrichProducts>(ProformaActionTypes.EnrichProducts),
    map(action => action.data),
    switchMap(data =>
      this.proformasApi.enrichProducts(data).pipe(
        map(() => new EnrichProductsSuccess()),
        catchError(error => of(new EnrichProductsFail(error)))
      )
    )
  );

  @Effect()
  addDelayProformas$ = this.actions$.pipe(
    ofType<AddDelayProformas>(ProformaActionTypes.AddDelayProformas),
    map(action => action.data),
    switchMap(data =>
      this.proformasApi.addDelayProforma(data).pipe(
        map(() => new AddDelayProformasSuccess()),
        catchError(error => of(new AddDelayProformasFail(error)))
      )
    )
  );

  @Effect({ dispatch: false })
  addDelayProformasSuccess$ = this.actions$.pipe(
    ofType<AddDelayProformasSuccess>(ProformaActionTypes.AddDelayProformasSuccess),
    map(action => {
      this.fs.emit({
        type: 'success',
        message: 'Atraso guardado correctamente'
      });
    })
  );

  @Effect({ dispatch: false })
  addDelayProformasFail$ = this.actions$.pipe(
    ofType<AddDelayProformasFail>(ProformaActionTypes.AddDelayProformasFail),
    map(action => {
      this.fs.emit({
        type: 'danger',
        message: 'Error al procesar el atraso'
      });
    })
  );

  @Effect({ dispatch: false })
  enrichProductsSuccess$ = this.actions$.pipe(
    ofType<EnrichProductsSuccess>(ProformaActionTypes.EnrichProductsSuccess),
    map(action => {
      this.fs.emit({
        type: 'success',
        message: 'Circuito productos enriquecidos iniciado'
      });
    })
  );

  @Effect({ dispatch: false })
  enrichProductsFail$ = this.actions$.pipe(
    ofType<EnrichProductsFail>(ProformaActionTypes.EnrichProductsFail),
    map(action => {
      this.fs.emit({
        type: 'danger',
        message: 'No se pudo iniciar el circuito para enriquecer los productos.'
      });
    })
  );

  @Effect()
  recalculateWeightedFob$: Observable<Action> = this.actions$.pipe(
    ofType<RecalculateWeightedFob>(ProformaActionTypes.RecalculateWeightedFob),
    map(action => [action.ProformaId]),
    switchMap(([ProformaId]) =>
      this.proformasApi.recalculate(ProformaId).pipe(
        concatMap(proformas => {
          return [
            new Load(proformas['followId']),
            new FollowShipmentActions.Load(proformas['followId'])
          ];
        }),
        catchError(error => of(new RecalculateWeightedFobFail(error)))
      )
    )
  );

  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType<Load>(ProformaActionTypes.Load),
    map(action => [action.FollowId, action.options]),
    switchMap(([FollowId, options]) =>
      this.proformasApi.get(FollowId, options).pipe(
        map(proformas => {
          // if (!options || !options.discrepanciesView) {
          // }
          return new LoadSuccess(proformas);
          // return new DiscrepanciesWebLoad("Cargando")
        }),
        catchError(error => of(new LoadFail(error)))
      )
    )
  );

  @Effect()
  create$: Observable<Action> = this.actions$.pipe(
    ofType<Create>(ProformaActionTypes.Create),
    map(action => action.data),
    switchMap(data =>
      this.proformasApi.create(data).pipe(
        map(
          (savedProforma: Proforma) => new CreateSuccess(savedProforma, data)
        ),
        catchError(error => of(new CreateFail(error)))
      )
    )
  );

  @Effect()
  createSuccess$ = this.actions$.pipe(
    ofType<CreateSuccess>(ProformaActionTypes.CreateSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Proforma creada' });
      // return new Load(action.data.FollowId);
    })
  );

  @Effect()
  upsertEnrichProducts$: Observable<Action> = this.actions$.pipe(
    ofType<UpsertEnrichProducts>(ProformaActionTypes.UpsertEnrichProducts),
    map(action => [action.data, action.supplierId]),
    concatMap(([data, supplierId]) =>
      this.proformasApi.upsertEnrichProducts(data).pipe(
        map(dataReturn => {
          return new UpsertEnrichProductsSuccess(dataReturn, supplierId);
        }),
        catchError(error => of(new UpsertEnrichProductsFail(error)))
      )
    )
  );

  @Effect()
  upsertEnrichProductsSuccess$ = this.actions$.pipe(
    ofType<UpsertEnrichProductsSuccess>(
      ProformaActionTypes.UpsertEnrichProductsSuccess
    ),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Producto Actualizado' });
      if (action.supplierId) {
        return new AllEnrichProducts({ SupplierId: action.supplierId });
      }
      return new AllEnrichProducts();
    })
  );

  @Effect({ dispatch: false })
  upsertEnrichProductsFail$ = this.actions$.pipe(
    ofType<UpsertEnrichProductsFail>(
      ProformaActionTypes.UpsertEnrichProductsFail
    ),
    map(action => {
      this.fs.emit({ type: 'danger', message: 'Error al actualizar' });
    })
  );

  @Effect()
  updateShipment$: Observable<Action> = this.actions$.pipe(
    ofType<UpdateShipment>(ProformaActionTypes.UpdateShipment),
    map(action => [action.ProformaId, action.data]),
    concatMap(([id, data]) =>
      this.proformasApi.update(id, data).pipe(
        map(proforma => {
          return new UpdateShipmentSuccess(data);
        }),
        catchError(error => of(new UpdateFail(error)))
      )
    )
  );

  @Effect({ dispatch: false })
  updateShipmentSuccess$ = this.actions$.pipe(
    ofType<UpdateShipmentSuccess>(ProformaActionTypes.UpdateShipmentSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Embarque actualizada' });
      // return new Load(action.data.FollowId)
    })
  );

  @Effect()
  updateOne$: Observable<Action> = this.actions$.pipe(
    ofType<UpdateOne>(ProformaActionTypes.UpdateOne),
    map(action => [action.ProformaId, action.data]),
    concatMap(([ProformaId, data]) =>
      this.proformasApi.updateOne(ProformaId, data).pipe(
        map(proforma => {
          return new UpdateOneSuccess(proforma);
        }),
        catchError(error => of(new UpdateOneFail(error)))
      )
    )
  );

  @Effect()
  update$: Observable<Action> = this.actions$.pipe(
    ofType<Update>(ProformaActionTypes.Update),
    map(action => [action.ProformaId, action.data]),
    concatMap(([id, data]) =>
      this.proformasApi.update(id, data).pipe(
        map(proforma => {
          // this.fs.emit({ type: 'success', message: 'Proforma actualizada' });
          return new UpdateSuccess(proforma, data);
        }),
        catchError(error => of(new UpdateFail(error)))
      )
    )
  );

  @Effect({ dispatch: false })
  updateProformaEditSuccess$ = this.actions$.pipe(
    ofType<UpdateProformaEditSuccess>(
      ProformaActionTypes.UpdateProformaEditSuccess
    ),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Proforma Actualizada' });
    })
  );

  @Effect()
  updateSuccess$ = this.actions$.pipe(
    ofType<UpdateSuccess>(ProformaActionTypes.UpdateSuccess),
    switchMap(action => {
      // return new Load(action);
      if (action.data.amountType) {
        this.fs.emit({ type: 'success', message: 'Ponderación estimada' });
        this._modalRef = this.modal.open(ProformaWeightedFobModalComponent);
        this._modalRef.componentInstance.proforma = action.proforma;
        // console.log(e);
        // console.log(this.actualValue);
        this._modalRef.result.then(
          result => {
            // do nothing
          },
          value => {
            // do nothing
          }
        );
      } else {
        this.fs.emit({ type: 'success', message: 'Proforma actualizada' });
      }

      const actions: Action[] = [
        new ProductShipmentActions.LoadByFollow(
          action.data.FollowId,
          null,
          action.proforma ? action.proforma.id : null
        )
      ];

      // la vista de discrepancias marca sus Updates con discrepanciesView:
      // recargamos la lista completa para reflejar los cambios sin depender
      // de los snapshots de los componentes
      if (action.data && action.data.discrepanciesView && (action.data.ParentId || action.data.FollowId)) {
        actions.push(
          new Load(action.data.ParentId || action.data.FollowId, {
            includeProvider: true,
            discrepanciesView: true
          })
        );
      }

      return actions;
    })
  );

  @Effect()
  shipmentUpdateCancel$: Observable<Action> = this.actions$.pipe(
    ofType<ShipmentUpdateCancel>(ProformaActionTypes.ShipmentUpdateCancel),
    map(action => [action.ProformaId, action.data]),
    concatMap(([id, data]) =>
      this.proformasApi.update(id, data).pipe(
        map(proforma => {
          return new ShipmentUpdateCancelSuccess(proforma, data);
        }),
        catchError(error => of(new ShipmentUpdateCancelFail(error)))
      )
    )
  );

  @Effect({ dispatch: false })
  shipmentUpdateCancelSuccess$ = this.actions$.pipe(
    ofType<ShipmentUpdateCancelSuccess>(
      ProformaActionTypes.ShipmentUpdateCancelSuccess
    ),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Embarque actualizada!' });
    })
  );

  @Effect()
  updateCancel$: Observable<Action> = this.actions$.pipe(
    ofType<UpdateCancel>(ProformaActionTypes.UpdateCancel),
    map(action => [action.ProformaId, action.data]),
    concatMap(([id, data]) =>
      this.proformasApi.update(id, data).pipe(
        map(proforma => {
          // this.fs.emit({ type: 'success', message: 'Proforma actualizada' });

          return new UpdateCancelSuccess(proforma, data);
        }),
        catchError(error => of(new UpdateCancelFail(error)))
      )
    )
  );

  @Effect()
  updateCancelSuccess$ = this.actions$.pipe(
    ofType<UpdateCancelSuccess>(ProformaActionTypes.UpdateCancelSuccess),
    switchMap(action => {
      const aux = {
        includeProvider: true,
        discrepanciesView: true
      };

      const FollowId = action.data.ParentId || action.data.FollowId;
      const ProformaId = action.proforma ? action.proforma.id : null;

      this.fs.emit({ type: 'success', message: 'Ponderación cancelada' });

      const actions: Action[] = [];

      if (FollowId) {
        actions.push(
          new ProductShipmentActions.LoadByFollow(FollowId, null, ProformaId),
          new Load(FollowId, aux),
          new SupplierFile(FollowId)
        );
      }

      return actions;
    })
  );

  @Effect()
  summary$: Observable<Action> = this.actions$.pipe(
    ofType<Summary>(ProformaActionTypes.Summary),
    switchMap(action =>
      this.proformasApi.getProformasSummary(action.followId).pipe(
        map(
          (savedSummary: Summary[]) =>
            new SummarySuccess(savedSummary, {
              followId: action.followId
            })
        )
      )
    )
  );

  @Effect()
  summarySuccess$ = this.actions$.pipe(
    ofType<SummarySuccess>(ProformaActionTypes.SummarySuccess),
    map(action => {
      // this.fs.emit({ type: 'success', message: 'Proformas actualizadas' });
      return new Load(action.data.followId);
    })
  );

  @Effect()
  generate$: Observable<Action> = this.actions$.pipe(
    ofType<Generate>(ProformaActionTypes.Generate),
    switchMap(action =>
      this.proformasApi.generate(action.FollowId).pipe(
        map(
          (savedProformas: Proforma[]) =>
            new GenerateSuccess(savedProformas, {
              FollowId: action.FollowId
            })
        ),
        catchError(error => of(new GenerateFail(error)))
      )
    )
  );

  @Effect()
  generateSuccess$ = this.actions$.pipe(
    ofType<GenerateSuccess>(ProformaActionTypes.GenerateSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Proformas generadas' });
      return new Summary(action.data.FollowId);
    })
  );

  @Effect()
  updateGenerate$: Observable<Action> = this.actions$.pipe(
    ofType<UpdateGenerate>(ProformaActionTypes.UpdateGenerate),
    switchMap(action =>
      this.proformasApi.updateGenerate(action.FollowId, action.options).pipe(
        map(
          (savedProformas: Proforma[]) =>
            new UpdateGenerateSuccess(savedProformas, {
              FollowId: action.FollowId,
              options: action.options
            })
        ),
        catchError(error => of(new UpdateGenerateFail(error)))
      )
    )
  );

  @Effect()
  acceptChangesSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<AcceptChangesSuccess>(DiscrepancyActionTypes.AcceptChangesSuccess),
    map(action => {
      let me = null;
      this.store.pipe(select(fromRoot.getMe)).subscribe(item => {
        me = item;
      });

      let UserId = action.data.UserId ? action.data.UserId : null;

      this.fs.emit({ type: 'success', message: 'Cambios realizados' });
      if (action.data.followId) {
        const options = {
          includeProvider: true
        };

        if (me && UserId && me.id === UserId) {
          this.router.navigate([
            `/follows/${action.data.followId}/discrepancies`
          ]);
        }

        return new Load(action.data.followId, options);
      }
    })
  );

  @Effect()
  updateGenerateSuccess$ = this.actions$.pipe(
    ofType<UpdateGenerateSuccess>(ProformaActionTypes.UpdateGenerateSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Proformas actualizadas' });
      if (action.data.options) {
        return new Load(action.data.FollowId, action.data.options);
      }
      return new Summary(action.data.FollowId);
    })
  );

  // al guardar cambios manuales de unidades/FOB desde la vista de
  // discrepancias el payload llega como array; recargamos las proformas
  // para que la tabla refleje los nuevos valores
  @Effect()
  bulkUpdateWebReload$: Observable<Action> = this.actions$.pipe(
    ofType(ProductShipmentActions.ProductShipmentActionTypes.BulkUpdateSuccess),
    filter((action: any) => Array.isArray(action.dataLoad)),
    map((action: any) => {
      // recargamos con el follow de la pagina (padre) para no perder
      // los proveedores/proformas de los demas hijos del follow
      const FollowId =
        action.dataLoad.length > 0
          ? action.dataLoad[0].ParentId || action.dataLoad[0].FollowId
          : null;

      return FollowId
        ? new Load(FollowId, {
            includeProvider: true,
            discrepanciesView: true
          })
        : new VoidAction();
    })
  );

  @Effect({ dispatch: false })
  exportProformasGroup$ = this.actions$.pipe(
    ofType<ExportGroup>(ProformaActionTypes.ExportGroup),
    tap(action => {
      console.log('exportProformasGroup ===>');
      this.api.exportProformasGroup(action.data);
    })
  );

  @Effect({ dispatch: false })
  proformaDownloabled$ = this.actions$.pipe(
    ofType<ProformasDetailDownloabled>(
      ProformaActionTypes.ProformasDetailDownloabled
    ),
    tap(action => this.proformasApi.downloadDetailProformas(action.data))
  );

  @Effect()
  exportProformasGroupSuccess$ = this.actions$.pipe(
    ofType<ExportGroupSuccess>(ProformaActionTypes.ExportGroupSuccess),
    map(action => {
      console.log('exportProformasGroupSuccess ===>');
      return new ExportGroupDownload(
        action.data.downloadUrl,
        action.data.name,
        action.data.total
      );
    })
  );

  @Effect({ dispatch: false })
  exportProformasGroupFail$ = this.actions$.pipe(
    ofType<ExportGroupFail>(ProformaActionTypes.ExportGroupFail),
    map(action => {
      console.log('exportProformasGroupFail ===>');
      this.fs.emit({ type: 'warning', message: action.error.message });
    })
  );

  @Effect({ dispatch: false })
  exportProformasGroupDownload$ = this.actions$.pipe(
    ofType<ExportGroupDownload>(ProformaActionTypes.ExportGroupDownload),
    map(action => [action.downloadUrl, action.name, action.total]),
    tap(([downloadUrl, name, total]: any) => {
      if (total > 0) {
        console.log('exportProformasGroupDownload');
        this.api.downloadProformasGroup(downloadUrl, name);
      }
    })
  );

  @Effect({ dispatch: false })
  exportProformasGroupDownloadSuccess$ = this.actions$.pipe(
    ofType<ExportGroupDownloadSuccess>(
      ProformaActionTypes.ExportGroupDownloadSuccess
    ),
    map(action => {
      console.log('exportProformasGroupDownloadSuccess');
      this.fs.emit({ type: 'success', message: 'Proformas descargadas!' });
    })
  );

  @Effect()
  addProducts = this.actions$.pipe(
    ofType<AddProducts>(ProformaActionTypes.AddProducts),
    map(action => [action.ProformaId, action.FollowId, action.ProductIds, action.data]),
    switchMap(([ProformaId, FollowId, ProductIds, data]) =>
      this.proformasApi.addProducts(ProformaId, ProductIds, FollowId, data).pipe(
        map(
          (res: any) => new AddProductsSuccess({ ...res, FollowId, ProformaId })
        ),
        catchError(error => of(new AddProductsFail(error)))
      )
    )
  );

  @Effect()
  addProductsSuccess = this.actions$.pipe(
    ofType<AddProductsSuccess>(ProformaActionTypes.AddProductsSuccess),
    map(action => action.data),
    map((data: any) => {
      this.fs.emit({ type: 'success', message: 'Producto(s) agregado(s)' });

      return new ProductShipmentActions.LoadByFollow(
        data.FollowId,
        null,
        data.ProformaId
      );
    })
  );

  @Effect()
  deleteProduct = this.actions$.pipe(
    ofType<DeleteProduct>(ProformaActionTypes.DeleteProduct),
    map(action => [
      action.ProformaId,
      action.FollowId,
      action.ProductId,
      action.ShipmentId,
      action.isDiscrepanciesView,
      action.ParentId
    ]),
    switchMap(
      ([
        ProformaId,
        FollowId,
        ProductId,
        ShipmentId,
        isDiscrepanciesView,
        ParentId
      ]) =>
        this.proformasApi.deleteProduct(ProformaId, ProductId, ShipmentId).pipe(
          switchMap((res: any) => {
            if (isDiscrepanciesView) {
              const aux = {
                includeProvider: true,
                discrepanciesView: true
              };
              return [
                new DeleteProductSuccess({ ...res, ProformaId, FollowId }),
                new Load(ParentId, aux)
              ];
            }
            return [new DeleteProductSuccess({ ...res, ProformaId, FollowId })];
          }),
          catchError(error => of(new DeleteProductFail(error)))
        )
    )
  );

  @Effect()
  deleteProductsSuccess = this.actions$.pipe(
    ofType<DeleteProductSuccess>(ProformaActionTypes.DeleteProductSuccess),
    map(action => action.data),
    map((data: any) => {
      this.fs.emit({ type: 'success', message: 'Producto eliminado' });

      return new ProductShipmentActions.LoadByFollow(
        data.FollowId,
        null,
        data.ProformaId
      );
    })
  );

  @Effect()
  deleteAllProforma$ = this.actions$.pipe(
    ofType<DeleteAllProforma>(ProformaActionTypes.DeleteAllProforma),
    map(action => [action.FollowId]),
    switchMap(([ProformaId]) =>
      this.proformasApi.deleteAllProforma(ProformaId).pipe(
        map((res: any) => new DeleteAllProformaSuccess({ ...res, ProformaId })),
        catchError(error => of(new DeleteAllProformaFail(error)))
      )
    )
  );

  @Effect()
  DeleteAllProformaSuccess = this.actions$.pipe(
    ofType<DeleteAllProformaSuccess>(
      ProformaActionTypes.DeleteAllProformaSuccess
    ),
    map(action => action.data),
    map((data: any) => {
      return new Generate(data.ProformaId);
    })
  );

  @Effect()
  search$: Observable<Action> = this.actions$.pipe(
    ofType<Search>(ProformaActionTypes.Search),
    map(action => [action.data, action.FollowId]),
    switchMap(([data, FollowId]) =>
      this.proformasApi.search(data, FollowId).pipe(
        map((ProformaIds: any[]) => new SearchSuccess(ProformaIds)),
        catchError(error => of(new SearchFail(error)))
      )
    )
  );

  @Effect()
  searchProduct$: Observable<Action> = this.actions$.pipe(
    ofType<SearchProduct>(ProformaActionTypes.SearchProduct),
    map(action => [action.ProformaId, action.data]),
    switchMap(([ProformaId, data]) =>
      this.proformasApi.searchProduct(ProformaId, data).pipe(
        map((ProductIds: any[]) => new SearchProductSuccess(ProductIds, data)),
        catchError(error => of(new SearchProductFail(error)))
      )
    )
  );

  @Effect()
  searchProductSuccess$ = this.actions$.pipe(
    ofType<SearchProductSuccess>(ProformaActionTypes.SearchProductSuccess),
    map(action => {
      if (action && action.ProductIds.length > 0) {
        this._modalRef = this.modal.open(ProductDisabledFobComponent);
        this._modalRef.componentInstance.ProductIdsDisabledByFob =
          action.ProductIds;

        this._modalRef.componentInstance.FollowId = action.extraData.FollowId;
        this._modalRef.componentInstance.ParentId = action.extraData.ParentId;
        this._modalRef.componentInstance.CountryId = action.extraData.CountryId;
        this._modalRef.componentInstance.chosenFob = action.extraData.fobType;
        this._modalRef.componentInstance.previousFob =
          action.extraData.previousFob;
        this._modalRef.componentInstance.ProformaId =
          action.extraData.ProformaId;

        this._modalRef.result.then(
          result => {
            // this._aliveUpdate = !this._aliveUpdate;
          },
          value => {
            if (value) {
              // this.fs.emit({
              //   type: 'success',
              //   message: 'Proforma Actualizada'
              // });
            }
          }
        );
        return new VoidAction();
      } else {
        return new Update(action.extraData.ProformaId, {
          fobType: action.extraData.fobType,
          FollowId: action.extraData.FollowId,
          CountryId: action.extraData.CountryId,
          previousFob: action.extraData.previousFob,
          ParentId: action.extraData.ParentId,
          includeProvider: action.extraData.includeProvider,
          discrepanciesView: action.extraData.discrepanciesView
        });
      }
    })
  );

  @Effect()
  updateStatus$: Observable<Action> = this.actions$.pipe(
    ofType<UpdateStatus>(ProformaActionTypes.UpdateStatus),
    map(action => [action.FollowId, action.data]),
    concatMap(([id, data]) =>
      this.proformasApi.updateStatus(id, data).pipe(
        map(proformas => {
          // this.fs.emit({ type: 'success', message: 'Proforma actualizada' });

          return new UpdateStatusSuccess(proformas);
        }),
        catchError(error => of(new UpdateFail(error)))
      )
    )
  );

  @Effect({ dispatch: false })
  updateStatusSuccess$ = this.actions$.pipe(
    ofType<UpdateStatusSuccess>(ProformaActionTypes.UpdateStatusSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Proformas Actualizadas' });
    })
  );

  @Effect({ dispatch: false })
  updateStatusWithSkusSuccess$ = this.actions$.pipe(
    ofType<ProcessFileWithSkusSuccess>(
      ProformaActionTypes.ProcessFileWithSkusSuccess
    ),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Proformas Actualizadas' });
    })
  );
}
